<template>
  <div class="users">
    <section class="table-section">
      <b-table
        :data="users"
        paginated
        :per-page="perPage"
        pagination-simple
        :debounce-search="200"
      >
        <b-table-column
          field="first_name"
          label="First Name"
          v-slot="props"
          :searchable="isSearchable"
          sortable
        >
          {{ props.row.first_name }}
        </b-table-column>

        <b-table-column
          field="last_name"
          label="Last Name"
          v-slot="props"
          :searchable="isSearchable"
          sortable
        >
          {{ props.row.last_name }}
        </b-table-column>

        <b-table-column
          field="email"
          label="Email"
          v-slot="props"
          :searchable="isSearchable"
          sortable
        >
          {{ props.row.email }}
        </b-table-column>

        <b-table-column
          v-if="project"
          field="Relationship"
          label="Relationship"
          v-slot="props"
          :searchable="isSearchable"
          sortable
        >
          <b-select
            placeholder="Select a relationship"
            size="is-small"
            expanded
            :value="
              props.row.relationship_unique_id ??
              props.row.relationship[0].unique_id
            "
            class="is-minimal"
            @input="updateRelationship(props.row, $event)"
          >
            <option
              v-for="relationship in project.relationships"
              :value="relationship.unique_id"
              :key="relationship.unique_id"
            >
              {{ relationship.name }}
            </option>
          </b-select>
        </b-table-column>

        <b-table-column
          v-if="project"
          :field="progressLabel"
          :label="progressLabel"
          v-slot="props"
          :searchable="isSearchable"
          sortable
        >
          <ColourCodedProgressBar :number="props.row.progress" />
        </b-table-column>

        <b-table-column
          v-else
          field="projects"
          label="Projects"
          v-slot="props"
          :searchable="isSearchable"
          sortable
        >
          <p v-for="project in props.row.projects" :key="project.id">
            <inertia-link :href="route('projects.show', project.unique_id)">
              {{ project.name }}
            </inertia-link>
          </p>
          <p
            v-for="project in props.row.feedback_projects"
            :key="project.id + '-feedback'"
          >
            <inertia-link :href="route('projects.show', project.unique_id)">
              {{ project.name }}
            </inertia-link>
          </p>
        </b-table-column>

        <b-table-column label="" v-slot="props">
          <inertia-link
            :href="
              route('users.show', {
                user: props.row.unique_id,
                project: project?.unique_id,
              })
            "
          >
            <b-button type="is-primary" size="is-small">View</b-button>
          </inertia-link>
        </b-table-column>
      </b-table>
    </section>
  </div>
</template>

<script>
import ColourCodedProgressBar from '../../Components/Management/ColourCodedProgressBar';

export default {
  components: {
    ColourCodedProgressBar,
  },
  props: {
    users: Array,
    perPage: {
      required: false,
      default: 10,
    },
    project: Object,
    progressLabel: {
      type: String,
      default: 'Given',
    },
    userType: {
      type: String,
      default: 'participants',
    },
    user: Object,
  },
  data() {
    return {};
  },
  methods: {
    updateRelationship: function (userSelectedFromTable, relationshipUniqueId) {
      let participantUniqueId =
        this.userType === 'participants'
          ? userSelectedFromTable.unique_id
          : this.user.unique_id;
      let feedbackGiverUniqueId =
        this.userType === 'participants'
          ? this.user.unique_id
          : userSelectedFromTable.unique_id;

      this.$inertia.patch(
        route('relationships.updateRelationship', [
          this.project.unique_id,
          participantUniqueId,
          feedbackGiverUniqueId,
        ]),
        {
          relationship: relationshipUniqueId,
        },
        {
          onSuccess: () => {
            this.$buefy.toast.open({
              message: 'Relationship Updated',
              type: 'is-success',
              position: 'is-top',
            });
          },
          onFailure: () => {
            this.$buefy.notification.open({
              message: 'Something went wrong',
              type: 'is-danger',
            });
          },
        }
      );
    },
  },
  computed: {
    isSearchable: function () {
      return this.users.length > 10;
    },
  },
};
</script>
